import * as React from "react";
import { Authenticated } from "./Authenticated";
import UserContext from "./UserContext";
import { Form, FormControl, Button } from "react-bootstrap"
import { ApiHelper, NavigationHelper, } from "./helpers";
import { ErrorMessages, SavedMessage } from "./components";

export const Forgot: React.FC = () => {
  //const [errors, setErrors] = React.useState<string[]>([])
  const [email, setEmail] = React.useState("");
  const [savedKey, setSavedKey] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [errors, setErrors] = React.useState<string[]>([]);
  const context = React.useContext(UserContext);

  const handleChange = (e: any) => {
    switch (e.currentTarget.id) {
      case "email": setEmail(e.currentTarget.value); break;
    }
  }

  const submitReset = async (email: string) => {
    setIsSubmitting(true);
    const resp: any = await ApiHelper.postAnonymous("/users/forgot", { email: email });
    if (!resp.emailed) {
      setErrors(["Email not found."]);
    } else {
      //window.location.href = "/login";
      setSavedKey(NavigationHelper.getRefreshKey());
    }
    setIsSubmitting(false);
  }

  const handleSubmit = (e: React.MouseEvent) => {
    let errors: string[] = [];
    if (email.length === 0) errors.push("Please enter an email address.");
    if (errors.length === 0) submitReset(email);
    setErrors(errors);
  }

  const getLoginBox = () => {
    return (
      <div id="loginBox" >
        <h2>Reset Password:</h2>
        <ErrorMessages errors={errors} />
        <SavedMessage customMessage="Password reset email sent" refreshKey={savedKey} />


        <Form.Group className="mb-3">
          <FormControl data-testid="forgot-email-input" type="text" aria-label="email" id="email" value={email} onChange={handleChange} placeholder="Email address" />
        </Form.Group>
        <Button data-testid="reset-password-button" type="submit" id="signInButton" size="lg" variant="primary" className="d-grid" disabled={isSubmitting} style={{ width: "100%" }} onClick={handleSubmit}>
          {(isSubmitting) ? "Please wait..." : "Reset Password"}
        </Button>

      </div>
    );
  }




  if (context.userName === "" || !ApiHelper.isAuthenticated) {
    return (<div className="smallCenterBlock">{getLoginBox()}</div>);
  } else {
    return <Authenticated />;
  }
};